module.exports = __webpack_public_path__ + "img/Exteriores.a29e6363.png";